import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import {BatteryReplacement, BtyReplacementParams} from '../battery-replacement.model';

export enum BatteryReplacementActionTypes {
  GetBatteryReplacements = '[BatteryReplacement] Get BatteryReplacement',
  GetBatteryReplacementFails = '[BatteryReplacement] Get BatteryReplacement Fails',
  LoadBatteryReplacements = '[BatteryReplacement] Load BatteryReplacements',
  AddBatteryReplacement = '[BatteryReplacement] Add BatteryReplacement',
  UpsertBatteryReplacement = '[BatteryReplacement] Upsert BatteryReplacement',
  AddBatteryReplacements = '[BatteryReplacement] Add BatteryReplacements',
  UpsertBatteryReplacements = '[BatteryReplacement] Upsert BatteryReplacements',
  UpdateBatteryReplacement = '[BatteryReplacement] Update BatteryReplacement',
  UpdateBatteryReplacements = '[BatteryReplacement] Update BatteryReplacements',
  DeleteBatteryReplacement = '[BatteryReplacement] Delete BatteryReplacement',
  DeleteBatteryReplacements = '[BatteryReplacement] Delete BatteryReplacements',
  ClearBatteryReplacements = '[BatteryReplacement] Clear BatteryReplacements'
}

export class LoadBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.LoadBatteryReplacements;

  constructor(public payload: { batteryReplacements: BatteryReplacement[] }) {}
}

export class AddBatteryReplacement implements Action {
  readonly type = BatteryReplacementActionTypes.AddBatteryReplacement;

  constructor(public payload: { batteryReplacement: BatteryReplacement }) {}
}

export class UpsertBatteryReplacement implements Action {
  readonly type = BatteryReplacementActionTypes.UpsertBatteryReplacement;

  constructor(public payload: { batteryReplacement: BatteryReplacement }) {}
}

export class AddBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.AddBatteryReplacements;

  constructor(public payload: { batteryReplacements: BatteryReplacement[] }) {}
}

export class UpsertBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.UpsertBatteryReplacements;

  constructor(public payload: { batteryReplacements: BatteryReplacement[] }) {}
}

export class UpdateBatteryReplacement implements Action {
  readonly type = BatteryReplacementActionTypes.UpdateBatteryReplacement;

  constructor(public payload: { batteryReplacement: Update<BatteryReplacement> }) {}
}

export class UpdateBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.UpdateBatteryReplacements;

  constructor(public payload: { batteryReplacements: Update<BatteryReplacement>[] }) {}
}

export class DeleteBatteryReplacement implements Action {
  readonly type = BatteryReplacementActionTypes.DeleteBatteryReplacement;

  constructor(public payload: { id: string }) {}
}

export class DeleteBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.DeleteBatteryReplacements;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.ClearBatteryReplacements;
}

export class GetBatteryReplacements implements Action {
  readonly type = BatteryReplacementActionTypes.GetBatteryReplacements;
  constructor(public payload: BtyReplacementParams ) {}
}

export class GetBatteryReplacementFails implements Action {
  readonly type = BatteryReplacementActionTypes.GetBatteryReplacementFails;
}

export type BatteryReplacementActions =
 LoadBatteryReplacements
 | AddBatteryReplacement
 | UpsertBatteryReplacement
 | AddBatteryReplacements
 | UpsertBatteryReplacements
 | UpdateBatteryReplacement
 | UpdateBatteryReplacements
 | DeleteBatteryReplacement
 | DeleteBatteryReplacements
 | ClearBatteryReplacements
 | GetBatteryReplacements
 | GetBatteryReplacementFails;
